export interface Subject {
    id: string;
    code: string;
    name: string;
    description?: string;
    credit_hours: number;
    grade_level: string;
    major_id?: string;
    major?: {
        id: string;
        code: string;
        name: string;
        description?: string;
        is_active: boolean;
    } | null;
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

export interface CreateSubjectData {
    code: string;
    name: string;
    description?: string;
    credit_hours: number;
    grade_level: string;
    major_id?: string | null;
    is_active?: boolean;
}

export interface UpdateSubjectData {
    code?: string;
    name?: string;
    description?: string;
    credit_hours?: number;
    grade_level?: string;
    major_id?: string | null;
    is_active?: boolean;
}

export interface SubjectFilters {
    search?: string;
    grade_level?: string;
    major_id?: string;
    is_active?: boolean;
    page?: number;
    per_page?: number;
}

import api from "./axios";

export const subjectApi = {
    async getAll(filters: SubjectFilters = {}): Promise<{
        success: boolean;
        message: string;
        data: { items: Subject[]; meta: any };
    }> {
        const response = await api.get("/v1/subjects", { params: filters });
        return response.data;
    },

    async getById(id: string): Promise<Subject> {
        const response = await api.get(`/v1/subjects/${id}`);
        return response.data.data;
    },

    async create(data: CreateSubjectData): Promise<Subject> {
        const response = await api.post("/v1/subjects", data);
        return response.data.data;
    },

    async update(id: string, data: UpdateSubjectData): Promise<Subject> {
        const response = await api.put(`/v1/subjects/${id}`, data);
        return response.data.data;
    },

    async delete(id: string): Promise<void> {
        await api.delete(`/v1/subjects/${id}`);
    },
};

export default subjectApi;
